import { render } from "./CreateFormsan.vue?vue&type=template&id=9747bd18"
import script from "./CreateFormsan.vue?vue&type=script&lang=js"
export * from "./CreateFormsan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__